import type { RootState } from '../../store';
import type { ModalState } from '../../types';

// `yuffie-shared`のmodal-manager.component.tsxで使われている
export const modalSelector = (state: RootState): ModalState => state.modal;
